import { render, staticRenderFns } from "./AttachmentTypes.vue?vue&type=template&id=d2eb8524&"
import script from "./AttachmentTypes.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports